import {WikiPage, WikiPageRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {SECTION_LABELS, wikiAdminListPath} from "../../../../components/wiki/sections";
import {TableCell} from "@mui/material";
import {SoftChip} from "../../../../components/kit";

export interface WikiPageListPageProps {
	section: string;
}


export const WikiPageListPage = ({section}: WikiPageListPageProps) => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<WikiPage> = {
		title: "Wiki de " + (SECTION_LABELS[section] || section),
		onClick: wikiAdminListPath(section),
		headers: [
			{title: "Título"},
			{title: "Visible"}
		],
		decorator: (bean: WikiPage) =>
			<>
				<TableCell>{bean.title}</TableCell>
				<TableCell>{bean.visible ? <SoftChip tone="success" label="Visible"/> : <SoftChip tone="neutral" label="Oculta"/>}</TableCell>
			</>,
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(WikiPageRestControllerApiFactory);
			return ctrl.pageWikiPage(section, currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};